import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import currencyShape from '@/propTypeShapes/currency'
import taxesShape from '@/propTypeShapes/taxes'
import LocalePrice from '@/utils/factory/price/localePrice'

import ReduxProvider from '../ReduxProvider'
import TaxInfoMessage from './TaxInfoMessage'

const Total = ({
  currency,
  isZeroDecimalCurrency,
  taxes: { flatTaxMultiplier, taxMultiplier },
  total: { amount, isFree, translations }
}) => {
  const totalFromState = useSelector(
    state => state.asset.selectedVariant.studentPrice
  )
  const [serverTotal, setServerTotal] = useState(amount)

  useEffect(() => {
    setServerTotal(totalFromState)
  }, [totalFromState])

  const { common_no_price_product } = translations

  const localePrice = new LocalePrice({
    currency,
    flatTaxMultiplier,
    isZeroDecimalCurrency,
    options: { hideCurrencyLabel: false },
    price: serverTotal,
    taxMultiplier,
    translations: { common_no_price_product }
  })

  return (
    <>
      <TaxInfoMessage />
      <div className='total-price'>
        {localePrice.formattedAmount}
        <If condition={currency.showing && !isFree}>
          {currency.storeCurrency}
        </If>
      </div>
    </>
  )
}

/*eslint-disable react/no-multi-comp*/
const Component = ({
  currency, isZeroDecimalCurrency, taxes, total
}) => (
  <ReduxProvider>
    <Total {...{
      currency,
      isZeroDecimalCurrency,
      taxes,
      total
    }}
    />
  </ReduxProvider>
)

export default Component

Total.propTypes = {
  currency: currencyShape,
  isZeroDecimalCurrency: PropTypes.bool.isRequired,
  taxes: taxesShape,
  total: PropTypes.shape({
    amount: PropTypes.string.isRequired,
    isFree: PropTypes.bool.isRequired,
    translations: PropTypes.shape({
      common_no_price_product: PropTypes.string.isRequired,
    })
  })
}

Component.propTypes = {
  currency: currencyShape,
  isZeroDecimalCurrency: PropTypes.bool.isRequired,
  taxes: taxesShape,
  total: PropTypes.shape({
    amount: PropTypes.string.isRequired,
    isFree: PropTypes.bool.isRequired,
    translations: PropTypes.shape({
      common_no_price_product: PropTypes.string.isRequired,
    })
  })
}
